import { useOutletContext } from "react-router-dom"
import { WxdhDetailStyle } from "./style"
import { ContestDetailResponse } from "types/contest"

const WxdhDetail = () => {
    const { detail } = useOutletContext<{ detail: ContestDetailResponse }>()
    const contestJSON = JSON.parse(detail?.pageCfg || "{}")

    const dataList: {
        word: string[],
        wordTip: string
        dateList: { name: string, id: number, start: string, end: string, dateIcon: string }[]
        priceList: { name: string, num: number, money: string, id: number }[]
        judgeList: { name: string, desc: string[], cover: string, id: number }[]
        evaluationCriteria: { name: string, content: string[], id: number }[]
        reviewProcess: { id: number, name: string, desc: string[] }[]
        ruleList: string[]
    } = contestJSON?.detail

    return <WxdhDetailStyle>
        {
            !!detail && <div className="detail">
                <div className="part part1">
                    <div className="title-wrap">
                        <div className="title">
                            <img src="https://cdn-prd.ggac.com/ggac/submatch/wxdh/wxdh-banner-title-left.png" className="left" />
                            <img src="https://cdn-prd.ggac.com/ggac/submatch/wxdh/wxdh-title-one.png" alt="" className="num" />
                            <div className="title-word">
                                <div><span>赛</span>事<span>引</span>言</div>
                            </div>
                            <img src="https://cdn-prd.ggac.com/ggac/submatch/wxdh/wxdh-banner-title-right.png" className="right" />
                        </div>
                        <div className="en-word">EVENT INTRODUCTION</div>
                    </div>
                    <div className="part1-content">
                        {
                            dataList.word.map(item => {
                                return <div className="word" key={item} dangerouslySetInnerHTML={{ __html: item }} />
                            })
                        }
                        <div className="wordTip">{dataList.wordTip}</div>
                    </div>
                    <img src="https://cdn-prd.ggac.com/ggac/submatch/wxdh/wxdh-icon1.png" className="icon1" />
                    <img src="https://cdn-prd.ggac.com/ggac/submatch/wxdh/wxdh-icon2.png" className="icon2" />
                </div>
                <div className="part part2">
                    <div className="title-wrap">
                        <div className="title">
                            <img src="https://cdn-prd.ggac.com/ggac/submatch/wxdh/wxdh-banner-title-left.png" className="left" />
                            <img src="https://cdn-prd.ggac.com/ggac/submatch/wxdh/wxdh-title-two.png" alt="" className="num" />
                            <div className="title-word">
                                <div><span>赛</span>程<span>安</span>排</div>
                            </div>
                            <img src="https://cdn-prd.ggac.com/ggac/submatch/wxdh/wxdh-banner-title-right.png" className="right" />
                        </div>
                        <div className="en-word">SCHEDULE </div>
                    </div>
                    <div className="part2-content">
                        {
                            dataList.dateList.map(item => {
                                return <div className="item" key={item.id}>
                                    <div className="name">{item.name}</div>
                                    <img src="https://cdn-prd.ggac.com/ggac/submatch/wxdh/wxdh-baner-part-tow-border2-line.png" className="date-line" />
                                    <div className="date">
                                        <div className="start">{item.start}</div>
                                        {
                                            item.dateIcon && <div>{item.dateIcon}</div>
                                        }
                                        {
                                            item.end && <div>{item.end}</div>
                                        }
                                    </div>
                                </div>
                            })
                        }
                        <img src="https://cdn-prd.ggac.com/ggac/submatch/wxdh/wxdh-baner-part-tow-icon.png" className="tree" alt="" />
                    </div>
                </div>
                <div className="part part3">
                    <div className="prize">
                        <div className="title-wrap">
                            <div className="title">
                                <img src="https://cdn-prd.ggac.com/ggac/submatch/wxdh/wxdh-banner-title-left.png" className="left" />
                                <img src="https://cdn-prd.ggac.com/ggac/submatch/wxdh/wxdh-title-three.png" alt="" className="num" />
                                <div className="title-word">
                                    <div><span>赛</span>事<span>奖</span>金</div>
                                </div>
                                <img src="https://cdn-prd.ggac.com/ggac/submatch/wxdh/wxdh-banner-title-right.png" className="right" />
                            </div>
                            <div className="en-word">COMPETITION PRIZE</div>
                        </div>
                        <div className="prize-content">
                            {
                                dataList.priceList.slice(0, 1).map(item => {
                                    return <div className="prize-item" key={item.id}>
                                        <div className="name">
                                            <div className="num">{item.name} {item.num}</div>
                                        </div>
                                        <img src="https://cdn-prd.ggac.com/ggac/submatch/wxdh/wxdh-baner-part-three-icon.png" alt="" />
                                        <div className="money">
                                            <span>￥</span>
                                            <span>{item.money}</span>
                                            <span>,</span>
                                            <span>000</span>
                                        </div>
                                    </div>
                                })
                            }
                        </div>
                        <div className="prize-content prize-content2">
                            {
                                dataList.priceList.slice(1, dataList.priceList.length).map(item => {
                                    return <div className="prize-item" key={item.id}>
                                        <div className="name">
                                            <img src="https://cdn-prd.ggac.com/ggac/submatch/wxdh/wxdh-baner-part-three-title-left.png" />
                                            <div className="num">{item.name} {item.num}</div>
                                            <img src="https://cdn-prd.ggac.com/ggac/submatch/wxdh/wxdh-baner-part-three-title-right.png" />
                                        </div>
                                        <img src="https://cdn-prd.ggac.com/ggac/submatch/wxdh/wxdh-baner-part-three-icon.png" alt="money-icon" />
                                        <div className="money">
                                            <span>￥</span>
                                            <span>{item.money}</span>
                                            <span>,</span>
                                            <span>000</span>
                                        </div>
                                    </div>
                                })
                            }
                        </div>
                    </div>
                </div>
                <div className="part part4">
                    <div className="title-wrap">
                        <div className="title">
                            <img src="https://cdn-prd.ggac.com/ggac/submatch/wxdh/wxdh-banner-title-left.png" className="left" />
                            <img src="https://cdn-prd.ggac.com/ggac/submatch/wxdh/wxdh-title-four.png" alt="" className="num" />
                            <div className="title-word">
                                <div><span>赛</span>事<span>评</span>委</div>
                            </div>
                            <img src="https://cdn-prd.ggac.com/ggac/submatch/wxdh/wxdh-banner-title-right.png" className="right" />
                        </div>
                        <div className="en-word">COMPETITION JUDGES</div>
                    </div>
                    <div className="judge">
                        {
                            dataList.judgeList.map(item => {
                                return <div className="judge-item" key={item.id}>
                                    <div className="judge-content">
                                        <div className="cover-wrap">
                                            <div className="cover" style={{ backgroundImage: `url(${item.cover})` }} />
                                        </div>
                                        <div className="name">{item.name}</div>
                                        {
                                            item.desc.map(desc => {
                                                return <div className="desc" key={desc}>{desc}</div>
                                            })
                                        }
                                    </div>
                                </div>
                            })
                        }
                    </div>
                    <img src="https://cdn-prd.ggac.com/ggac/submatch/wxdh/wxdh-icon3.png" className="icon3" />
                </div>
                <div className="part part5">
                    <div className="title-wrap">
                        <div className="title">
                            <img src="https://cdn-prd.ggac.com/ggac/submatch/wxdh/wxdh-banner-title-left.png" className="left" />
                            <img src="https://cdn-prd.ggac.com/ggac/submatch/wxdh/wxdh-title-five.png" alt="" className="num" />
                            <div className="title-word">
                                <div><span>评</span>审<span>标</span>准</div>
                            </div>
                            <img src="https://cdn-prd.ggac.com/ggac/submatch/wxdh/wxdh-banner-title-right.png" className="right" />
                        </div>
                        <div className="en-word">EVALUATION CRITERIA</div>
                    </div>
                    <div className="evaluationCriteria">
                        {
                            dataList.evaluationCriteria.map(item => {
                                return <div className="evaluation" key={item.id}>
                                    <div className="name">{item.name}</div>
                                    {
                                        item.content.map(desc => {
                                            return <div className="desc" key={desc}>{desc}</div>
                                        })
                                    }
                                </div>
                            })
                        }
                    </div>

                </div>
                <div className="part part6">
                    <div className="title-wrap">
                        <div className="title">
                            <img src="https://cdn-prd.ggac.com/ggac/submatch/wxdh/wxdh-banner-title-left.png" className="left" />
                            <img src="https://cdn-prd.ggac.com/ggac/submatch/wxdh/wxdh-title-six.png" alt="" className="num" />
                            <div className="title-word">
                                <div><span>评</span>审<span>环</span>节</div>
                            </div>
                            <img src="https://cdn-prd.ggac.com/ggac/submatch/wxdh/wxdh-banner-title-right.png" className="right" />
                        </div>
                        <div className="en-word">REVIEW PROCESS</div>
                    </div>
                    <div className="part6-content">
                        {
                            dataList.reviewProcess.map(item => {
                                return <div className="item" key={item.id}>
                                    <div className="name">{item.name}</div>
                                    {
                                        item.desc.map(desc => {
                                            return <div className="desc" key={desc}>{desc}</div>
                                        })
                                    }
                                </div>
                            })
                        }
                        <img src="https://cdn-prd.ggac.com/ggac/submatch/wxdh/wxdh-baner-part-tow-icon.png" className="tree" alt="" />
                    </div>
                    <img src="https://cdn-prd.ggac.com/ggac/submatch/wxdh/wxdh-icon4.png" className="icon4" />
                </div>
                <div className="part part7">
                    <div className="title-wrap">
                        <div className="title">
                            <img src="https://cdn-prd.ggac.com/ggac/submatch/wxdh/wxdh-banner-title-left.png" className="left" />
                            <img src="https://cdn-prd.ggac.com/ggac/submatch/wxdh/wxdh-title-seven.png" alt="" className="num" />
                            <div className="title-word">
                                <div><span>参</span>赛<span>须</span>知</div>
                            </div>
                            <img src="https://cdn-prd.ggac.com/ggac/submatch/wxdh/wxdh-banner-title-right.png" className="right" />
                        </div>
                        <div className="en-word">ENTRY INFORMATION</div>
                    </div>
                    <div className="rule">
                        {
                            dataList.ruleList.map((item, index) => {
                                return <div className="rule-item" key={item}>
                                    <div>{index + 1}、</div>
                                    <div>{item}</div>
                                </div>
                            })
                        }
                    </div>
                </div>
                <div className="bottom">
                    <img src="https://cdn-prd.ggac.com/ggac/submatch/wxdh/wxdh-border-logo.png" className="bottom-logo" />
                    <div className="bottom-tree">
                        <img src="https://cdn-prd.ggac.com/ggac/submatch/wxdh/wxdh-icon5.png" />
                        <img src="https://cdn-prd.ggac.com/ggac/submatch/wxdh/wxdh-icon6.png" />
                    </div>
                </div>
            </div>
        }
    </WxdhDetailStyle>
}

export default WxdhDetail